import React from 'react';
import { createRoot } from 'react-dom/client';

import history from './history';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import store from './store/index';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter history={history}>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);
